import { useRef, useState, ForwardedRef, useImperativeHandle, forwardRef } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import EfTab, { EcoTabItemProps } from 'eco-design-components/elements/eco-tab';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import EfImg from '@elem/ui/ef-img';
import { useIntroductionList } from './config';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';

interface IProps {
    type?: string;
}
export type IntroductionHandle = {
    changeActive: (type: string) => void;
};

const Introduction = ({ type }: IProps, ref: ForwardedRef<IntroductionHandle>) => {
    const { t } = useLang('membersday.membersdayintroduction25');
    const [active, setActive] = useState('a');
    const { locale } = getLocal();
    const list = useIntroductionList(locale, active);
    const [swiper, setSwiper] = useState<any>(null);

    const tabList = [
        {
            tabValue: 'a',
            tabLabel: t('introduction_tab1') as string,
            tabDataLayer: {
                event: 'uaEvent',
                event_name: 'tab_click',
                list_name: t('introduction_title'),
                button_name: t('introduction_tab1'),
            },
        },
        {
            tabValue: 'b',
            tabLabel: t('introduction_tab2') as string,
            tabDataLayer: {
                event: 'uaEvent',
                event_name: 'tab_click',
                list_name: t('introduction_title'),
                button_name: t('introduction_tab2'),
            },
        },
    ];

    useImperativeHandle(ref, () => ({
        changeActive: (type: string) => {
            setActive(type);
        },
    }));

    const handleChangeActive = (item: EcoTabItemProps) => {
        swiper?.slideTo(0);
        // gtm.push(item.tabDataLayer);
        setActive(item.tabValue);
    };

    return (
        <div className={styled.Introduction} id="introduction">
            <h5 className="introduction-title">{t('introduction_title')}</h5>
            <p className="introduction-desc">{t('introduction_desc')}</p>
            <EfTab activeKey={active} theme="black" items={tabList} onChange={handleChangeActive} />

            <Swiper
                className="introduction-swiper"
                modules={[Navigation, Pagination]}
                // centeredSlides={gap !== 16}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation
                pagination={{ clickable: true }}
                onSwiper={(swiperIns: any) => setSwiper(swiperIns)}
            >
                {list.map((item, ind) => (
                    <SwiperSlide className={`card item-${ind + 1}`} key={ind}>
                        <div className="item-img">
                            <EfImg pc={item?.pc} h5={item?.h5} />
                        </div>
                        <div className="item-info">
                            {item.title && <p className="item-title">{item.title}</p>}
                            <p className="item-desc">{item.desc}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default forwardRef<IntroductionHandle, IProps>(Introduction);
